import UserInfo from './UserInfo'

declare global {
  interface Window {
    Intercom?: (eventName: string, payload: any) => void
  }
}

export function init (appID: string) {
  appendScriptTag(appID)
}

function appendScriptTag (appID: string) {
  const js = document.createElement('script')
  js.type = 'text/javascript'
  js.innerHTML = scriptBody(appID)
  document.head.appendChild(js)
}

function scriptBody (appID: string) {
  return `(function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/' + '${appID}';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s, x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();`
}

export function trackUser (appID: string, userInfo: UserInfo) {
  if (!window.Intercom) {
    console.error('Missing Intercom window var')
    return
  }

  window.Intercom('boot', {
    app_id: appID,
    hide_default_launcher: true,
    email: userInfo.email,
    name: userInfo.firstName + ' ' + userInfo.lastName,
    user_id: userInfo.userId,
    admin: userInfo.isAdmin,
    company: {
      id: userInfo.workspaceId,
      name: userInfo.workspaceName,
      type: userInfo.workspaceType
    }
  })
}
